export const lang = Object.freeze({
  ENGLISH: 'en',
  ITALIAN: 'it',
  FRENCH: 'fr',
  ARABIC: 'ar',
  RUSSIAN: 'ru',
})
